__webpack_require__.hmrF = () => ("glossary." + __webpack_require__.h() + ".hot-update.json");